// test1888
(1888 && 0);
